import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "../features/bookings/booking/bookingsSlice";
import carAvailabilityReducer from "../features/bookings/carAvailability/carAvailabilitySlice";
import carsReducer from "../features/dashboard/ManageCars/carsSlice";
import blackoutDatesReducer from "../features/dashboard/ManageBookings/Blackout/BlackoutSlice";
import pricingReducer from "../features/dashboard/ManagePricing/pricingSlice";

export const store = configureStore({
  reducer: {
    bookings: bookingReducer,
    carAvailability: carAvailabilityReducer,
    cars: carsReducer,
    blackoutDates: blackoutDatesReducer,
    pricing: pricingReducer,
  },
  devTools: process.env.NODE_ENV === "production",
});
